/* istanbul ignore file */

import React from 'react';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import {
    ModalProvider,
    VerboseProvider,
    AvatarUrlProvider,
    SkeletonLoader,
    BoxSkeleton,
} from '@europrocurement/flexy-components';
import { UseKeycloakService } from '@europrocurement/l2d-keycloak';
import { useLoadingStatus } from '@europrocurement/l2d-hooks';

import { APIS_ENUM, getBasePathFromApiName, INIT_STATE } from '@europrocurement/l2d-domain';

import { WebsocketProvider } from '@europrocurement/l2d-websocket';
import L2DTheme from './Theme';
import Router from './router/router';
import 'react-grid-layout/css/styles.css';

const router = createBrowserRouter(Router);

const App = function () {
    const routing = router;
    const kc = UseKeycloakService();
    const theme = L2DTheme();

    const { loading } = useLoadingStatus({ checkReady: () => kc.isInitialized() });

    return (
        <WebsocketProvider
            baseWebsocketUrl={
                getBasePathFromApiName(APIS_ENUM.WS_MESSAGERIE) || INIT_STATE.api.wsMessagerie
            }
        >
            <AvatarUrlProvider>
                <VerboseProvider>
                    <ModalProvider>
                        <ThemeProvider theme={theme}>
                            <SkeletonLoader
                                isLoading={loading}
                                skeleton={
                                    <Box
                                        sx={{
                                            width: '100vw',
                                            height: '100vh',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'space-evenly',
                                        }}
                                    >
                                        <BoxSkeleton sx={{ width: '13vw', height: '97vh' }} />
                                        <Box
                                            sx={{
                                                width: '84vw',
                                                height: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'space-evenly',
                                            }}
                                        >
                                            <BoxSkeleton sx={{ width: '84vw', height: '7vh' }} />
                                            <BoxSkeleton sx={{ width: '84vw', height: '89vh' }} />
                                        </Box>
                                    </Box>
                                }
                            >
                                {!loading ? <RouterProvider router={routing} /> : null}
                            </SkeletonLoader>
                            <CssBaseline />
                        </ThemeProvider>
                    </ModalProvider>
                </VerboseProvider>
            </AvatarUrlProvider>
        </WebsocketProvider>
    );
};

export default App;
